export default __webpack_public_path__ + "static/media/dubai-visa-process.ac7a8f77.jpg";